import {
  ViolationReportAdditionalReasonApi,
  ViolationReportContextTypeApi,
  ViolationReportReasonApi,
} from 'api-typings/users/users';

export enum ViolationReportReasonText {
  COPIED_WORK_FROM_USER = 'They copied my work',
  COPIED_WORK_FROM_SOMEONE_ELSE = 'They copied work from another source',
  WORK_DOES_NOT_MATCH_REQUIREMENTS = 'Work does not match requirements',
  EXPLICIT_OR_INAPPROPRIATE_CONTENT = 'Submitted work with explicit or inappropriate content',
  LOW_QUALITY_WORK = 'Low-quality work',
  PUBLIC_DISPLAY_OF_COMMUNICATION_DETAILS = 'They are publicly displaying their contact information',
  INAPPROPRIATE_LANGUAGE = 'They have been using inappropriate language',
  DOES_NOT_MATCH_PROJECT_DESCRIPTION = 'Does not match project description',
  DOES_NOT_PROVIDE_ENOUGH_INFORMATION = 'Unclear or does not provide enough information',
  CONTAINS_CONTACT_INFORMATION = 'Contains contact information',
  OTHER = 'Other',
}

export enum ReportStep {
  REASON = 1,
  DESCRIPTION = 2,
  SUCCESS = 3,
}

export interface ViolationReportDetails {
  readonly violatorUserId: number;
  readonly contextId: number;
  readonly contextType: ViolationReportContextTypeApi;
}

type ViolationReasonMapping = {
  readonly [key in ViolationReportReasonText]: {
    readonly reason: ViolationReportReasonApi;
    readonly additionalReason: ViolationReportAdditionalReasonApi;
  };
};

export const VIOLATION_REASON_TEXT_MAPPING: ViolationReasonMapping = {
  [ViolationReportReasonText.OTHER]: {
    reason: ViolationReportReasonApi.OTHER,
    additionalReason: ViolationReportAdditionalReasonApi.OTHER,
  },
  [ViolationReportReasonText.PUBLIC_DISPLAY_OF_COMMUNICATION_DETAILS]: {
    reason: ViolationReportReasonApi.CONTACTS,
    additionalReason:
      ViolationReportAdditionalReasonApi.PUBLIC_DISPLAY_OF_COMMUNICATION_DETAILS,
  },
  [ViolationReportReasonText.EXPLICIT_OR_INAPPROPRIATE_CONTENT]: {
    reason: ViolationReportReasonApi.OTHER,
    additionalReason:
      ViolationReportAdditionalReasonApi.EXPLICIT_OR_INAPPROPRIATE_CONTENT,
  },
  [ViolationReportReasonText.COPIED_WORK_FROM_USER]: {
    reason: ViolationReportReasonApi.OTHER,
    additionalReason: ViolationReportAdditionalReasonApi.COPIED_WORK_FROM_USER,
  },
  [ViolationReportReasonText.COPIED_WORK_FROM_SOMEONE_ELSE]: {
    reason: ViolationReportReasonApi.OTHER,
    additionalReason:
      ViolationReportAdditionalReasonApi.COPIED_WORK_FROM_SOMEONE_ELSE,
  },
  [ViolationReportReasonText.WORK_DOES_NOT_MATCH_REQUIREMENTS]: {
    reason: ViolationReportReasonApi.OTHER,
    additionalReason:
      ViolationReportAdditionalReasonApi.WORK_DOES_NOT_MATCH_REQUIREMENTS,
  },
  [ViolationReportReasonText.LOW_QUALITY_WORK]: {
    reason: ViolationReportReasonApi.OTHER,
    additionalReason: ViolationReportAdditionalReasonApi.LOW_QUALITY_WORK,
  },
  [ViolationReportReasonText.INAPPROPRIATE_LANGUAGE]: {
    reason: ViolationReportReasonApi.OTHER,
    additionalReason: ViolationReportAdditionalReasonApi.INAPPROPRIATE_LANGUAGE,
  },
  [ViolationReportReasonText.DOES_NOT_MATCH_PROJECT_DESCRIPTION]: {
    reason: ViolationReportReasonApi.FAKE,
    additionalReason: ViolationReportAdditionalReasonApi.OTHER,
  },
  [ViolationReportReasonText.DOES_NOT_PROVIDE_ENOUGH_INFORMATION]: {
    reason: ViolationReportReasonApi.FAKE,
    additionalReason: ViolationReportAdditionalReasonApi.OTHER,
  },
  [ViolationReportReasonText.CONTAINS_CONTACT_INFORMATION]: {
    reason: ViolationReportReasonApi.CONTACTS,
    additionalReason: ViolationReportAdditionalReasonApi.OTHER,
  },
};
